import {
    SUBMIT_CHAMPION_REQUEST,
    SUBMIT_CHAMPION_SUCCESS,
    SUBMIT_CHAMPION_FAILURE,
} from "../actions/championAgentActions";

const initialState = {
  loading: false,
  successMessage: "",
  errorMessage: "",
};

export const championReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_CHAMPION_REQUEST:
      return { ...state, loading: true, successMessage: "", errorMessage: "" };
    case SUBMIT_CHAMPION_SUCCESS:
      return { ...state, loading: false, successMessage: action.payload };
    case SUBMIT_CHAMPION_FAILURE:
      return { ...state, loading: false, errorMessage: action.payload };
    default:
      return state;
  }
};